import { render } from "./ListeHospitalisation.vue?vue&type=template&id=4d0efc6b&scoped=true"
import script from "./ListeHospitalisation.vue?vue&type=script&lang=js"
export * from "./ListeHospitalisation.vue?vue&type=script&lang=js"

import "./ListeHospitalisation.vue?vue&type=style&index=0&id=4d0efc6b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0efc6b"]])

export default __exports__